<template>
    <div
		class="select-wrapper"
		ref="selectField"
        v-on-clickaway="blur"
		@blur="blur()"
        @click.self="toggle()"
        @focus="focus()" tabindex="0"
        :class="{
			'active' : isActive, 'empty' : selected=='',
			'editable' : hasOther && editable,
			'with-icon' : iconProp,
			'disabled' : disable
		}"
	>
        <label v-if="label">
			<span v-if="required">*</span> {{ label }}
		</label>

        <div
			class="select"
			:class="{'show' : showOptions}"
			@click.self="toggle()"
		>
			<div
				class="option-icon"
				:style="`background-image: url('${apiUrl}/flags/${selectedIcon}')`"
				v-if="iconProp && label && selected[valueProp]"
			/>

            <input
				type="text"
				class="selected-item"
				:placeholder="placeholderText"
				v-model="selected[displayProp]"
				ref="selected_item"
				tabindex="-1"
				@focus="focus()"
				@blur="blurInput()"
				@input="inputValue($event.target.value)"
			/>

            <span class="arrow" />

            <ul class="option-wrapper">
				<li class="search-wrapper">
					<input
						type="text"
						class="search"
						ref="search"
						@focus="searchFocus()"
						@keyup="search($event.target.value)"
						tabindex="-1"
						v-model="searchText"
					>

					<img src="@/assets/img/icon/ic_search.png" class="search-icon">
				</li>

				<template v-if="items.length" >
                <li
					class="option"
					:key="key"
					v-for="(item, key) in items"
					:class="{
						'selected' : selected[idProp] === item[idProp] && Object.keys(selected).length > 0
					}"
					@click="update(item, key)"
				>
					<div
						class="option-icon"
						:style="`background-image: url('${apiUrl}/flags/${item[iconProp]}')`"
						v-if="iconProp"
					/>

					{{ item[displayProp] }}
				</li>
				</template>
				<li v-else-if="searchText && !items.length" class="no-result"> No result found </li>

				<li
					class="option"
					v-if="hasOther"
					@click="update('other')"
				>
					Other
				</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => {}
		},

		items: {
			type: Array,
			default: () => []
		},

		idProp: {
			type: String,
			default: 'id'
		},

		valueProp: {
			type: String,
			default: '',
			required: true
		},

		displayProp: {
			type: String,
			default: '',
			required: true
		},

		iconProp: {
			type: String,
			default: ''
		},

		label: {
			type: String,
			default: ''
		},

		placeholder: {
			type: String,
			default: ''
		},

		hasOther: {
			type: Boolean,
			default: false
		},

        required: {
			type: Boolean,
			default: false
		},

		disable: {
			type: Boolean,
			default: false
		},

		deselect: {
			type: Boolean,
			default: false
		},

		customSearch: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			isActive: false,
			showPassword: false,
			showOptions: false,
			selected: this.value,
			selectedIcon: '',
			editable: false,
			apiUrl: process.env.VUE_APP_API_URL,
			searchText: ''
		}
	},

	watch: {
		value (val) {
			this.selected = val
		}
	},

	deactivated () {
		this.searchText = ''
		this.search('')
	},

	beforeDestroy () {
		this.searchText = ''
		this.search('')
	},

	computed: {
		placeholderText () {
			if (this.editable) {
				return 'Enter company type'
			} else {
				return this.placeholder
			}
		}
	},

	methods: {
		inputValue (value) {
			if (this.editable) {
				this.$emit('input', {
					[this.idProp]: value,
					[this.displayProp]: value
				})
			}
		},

		resetData () {
			this.selected = {}
		},

		focus () {
			this.isActive = true
		},

		searchFocus () {
			this.isActive = true
			this.showOptions = true

			this.$refs.selectField.querySelector('.option-wrapper').scrollTo(0, 0)
		},

		toggle () {
			this.showOptions = !this.showOptions

			if (this.showOptions) {
				this.$refs.search.focus()
			}
		},

		blur () {
			this.isActive = false
			this.showOptions = false
		},

		blurInput () {
			this.blur()
			this.editable = false
		},

		update (val, itemIndex) {
			this.showOptions = false
			if (this.disable) return

			if (val === 'other') {
				this.editable = true
				this.selected = {}
				this.$refs.selected_item.focus()
			} else {
				if (this.selected[this.idProp] === val[this.idProp] && this.deselect) {
					this.selected = {}
				} else {
					this.selected = val
				}

				this.editable = false
			}

			this.setLabelIcon(itemIndex)
			this.$emit('input', this.selected)
		},

		setLabelIcon (itemIndex) {
			if (this.iconProp) {
				this.selectedIcon = this.items[itemIndex][this.iconProp]
			}
		},

		search (filter) {
			if (this.customSearch) {
				this.$emit('search', filter)
				return
			}

			let a = this.$refs.selectField.querySelectorAll('.option')
			a.forEach(element => {
				if (element.innerText.toUpperCase().indexOf(filter.toUpperCase()) > -1) {
					element.style.display = ''
				} else {
					element.style.display = 'none'
				}
			})
		},

		setItemDisplay (item) {
			if (this.displayProp === '') return Object.values(item)[0]

			// return item[this.displayProp]
		}
	}
}
</script>
<style lang="scss" scoped>
.select-wrapper {
	cursor: pointer;
	position: relative;
	outline: none;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	transition: 0.3s;

	&.disabled {
		opacity: 0.7;
		pointer-events: none;
	}

	label {
		text-align: left;
		font-weight: 400;
		font-size: 13px;
		z-index: +1;
		height: 39px;
		display: flex;
		align-items: flex-end;

        span {
			color: #BC3211;
            margin-right: 2px;
		}

		.option-icon {
			width: 20px;
			margin-right: 5px;
			display: inline-block;
			background-color: #d3d3d3;
		}
    }

	.select {
        position: relative;
		display: block;
		text-align: left;
		width: 100%;
		outline: none;
		font-size: 16px;
		color: #4A4C50;
        border: none;
        padding: 1px;

		.selected-item {
			pointer-events: none;
			border: none;
			outline: none;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding-right: 20px !important;
            color: #778395;
		}

        .arrow {
            display: inline-block;
            border-top: 2px solid #BCBCCB;
            border-right: 2px solid #BCBCCB;
            position: absolute;
            bottom: 15px;
            right: 0;
            height: 7px;
            width: 7px;
            transform: rotateZ(135deg);
			pointer-events: none;
		}

        .option-wrapper {
            position: absolute;
			overflow: hidden;
            list-style: none;
            width: 100%;
            background-color: #fff;
            z-index: +15;
            max-height: 0;
            transition: max-height 0.3s ease;
            pointer-events: none;

			.search-wrapper {
				position: relative;
				opacity: 0;

				.search {
					flex: 1 1 auto;
					font-size: 16px;
					line-height: 20px;
					color: #4A4C50;
					border: none;
					box-shadow: 0 0 2px #979cac;
					border-radius: 0 0 5px 5px;
					padding: 5px 30px 5px 20px;
					width: 100%;
				}

				.search-icon {
					position: absolute;
					width: 15px;
					height: 15px;
					top: 6px;
					right: 10px;
					pointer-events: none;
				}
			}

            .option {
                padding: 13px 20px;
                display: none;
				transition: 0.3s ease;

                &:hover {
                    background-color: #2DC4B6;
                    color: #fff;
                }

				&.selected {
					background-color: #2DC4B6;
                    color: #fff;
				}
			}

			.no-result {
				padding: 13px 20px;
				pointer-events: none;
				cursor: default;
				text-align: center;
			}
		}

		&.show {
			.option-wrapper {
				max-height: 160px;
				border-bottom: 1px solid #979CAC;
				border-left: 1px solid #979CAC;
				border-right: 1px solid #979CAC;
				border-radius: 0 0 4px 4px;
				pointer-events: all;
				overflow-y: auto;

				.option {
					display: block;
				}

				.search-wrapper {
					opacity: 1;
				}
			}

			.arrow {
				transform: rotateZ(-45deg);
			}
		}
	}

	// style for line type select
	&.select-line {
        height: 30px;

		label {
			color: #979CAC;
			pointer-events: none;
		}

		.select {
			border-bottom: 2px solid #E9E9F0;
			margin: 10px 0;
			padding-bottom: 10px;
			height: 30px;

			.selected-item {
				font-size: 16px;
				line-height: 20px;
                display: inline-block;
                transition: display 1s ease;
				color: #4A4C50;

				&::placeholder {
					font-size: 16px;
					color: #979CAC;
				}
			}

			.option-wrapper {
				top: 30px;
			}
        }

		&:hover {
			.select {
				border-bottom: 2px solid #979CAC;
			}
		}

		&.empty {
			.select {
				height: 0;
				padding: 0;
			}

			label {
				font-size: 16px;
				color: #575B5C;
			}

            .selected-item {
                display: none;
            }
		}

		&.active{

			label {
				color: #2DC4B6;
				font-size: 13px;
			}

			.select {
                border-bottom: 3px solid #2DC4B6;
				height: 30px;
				padding-bottom: 10px;

				.selected-item {
					display: inline-block;
				}
            }
		}

		&.editable {
			.select {
				height: 30px;
				padding-bottom: 10px;

				.selected-item {
					pointer-events: all;
					display: inline-block;
				}
			}

			label {
				color: #2DC4B6;
				font-size: 13px;
			}
		}

		&.with-icon {
			&.empty {
				padding-bottom: 0px;
				.select {
					padding-bottom: 0px;
				}
			}

			&.active {
				.select {
					padding-bottom: 27px;
				}
			}

			.select {
				display: flex;
				height: 20px;
				padding-bottom: 27px;

				.option-icon {
					width: 20px;
					margin-right: 5px;
					display: inline-block;
					height: 12px;
					margin-top: 5px;
					background-color: #d3d3d3;
				}

				.option-wrapper {
					.option {
						display: flex;
						align-items: center;

						.option-icon {
							margin-top: 2px;
						}
					}
				}

				.selected-item {
					height: 20px;
				}
			}
		}
    }

	// box type select
	&.select-box {

		label {
			pointer-events: none;
			font-size: 16px;
			color: #575B5C;
			padding: 10px 0;
			width: 100%;
		}

		.arrow {
			right: 10px;
		}

		.select {
			border: 1px solid #C6C6C6;
			border-radius: 4px;

			.selected-item {
				border: none;
				width: 100%;
				border-radius: 4px;
				font-size: 13px;
				padding: 10px;

				&::placeholder {
					color: #CECFD0;
					font-size: 13px;
				}
			}

			.option-wrapper {
				top: 39px;
				left: 0;
			}
		}

		&:hover {
			label {
				color: #2DC4B6;
			}

			.select {
				border: 1px solid #2DC4B6;
			}
		}

		&.active{

			label {
				color: #2DC4B6;
			}

			.select {
				border: 1px solid #2DC4B6;
			}
		}

		&.with-icon {
			&.empty {
				padding-bottom: 0px;
			}

			&.active {
				.select {
					padding-bottom: 27px;
				}
			}

			.select {
				display: flex;
				height: 20px;
				padding-bottom: 27px;

				.option-icon {
					width: 20px;
					display: inline-block;
					height: 12px;
					margin: 7px 5px 0 7px;
					background-color: #d3d3d3;
				}

				.option-wrapper {
					top: 28px;
					.option {
						display: flex;
						align-items: center;

						.option-icon {
							margin: 2px 5px 0 0px;
						}
					}
				}

				.arrow {
					bottom: 10px;
				}

				.selected-item {
					height: 27px;
				}
			}
		}
	}
}
</style>
